export default __webpack_public_path__ + "static/media/Allocate-documentation.2d365e38.md";